import * as Sentry from "@sentry/react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app/App";
import { i18nReady } from "./core/i18n/i18next";

Sentry.init({
  dsn: "https://572544f0533f09bf05012bda684184c2@o4510783066538064.ingest.de.sentry.io/4511229181558864",
  environment: import.meta.env.MODE,
  sendDefaultPii: true,
});

const main = async () => {
  // Without catalogs every `t()` would render its key. A failed chunk load
  // still renders the app (keys showing beats a blank page).
  await i18nReady.catch(() => undefined);
  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
};

main();
